<template>
  <div
    class="faq-question-content"
    v-bind:class="{ active: isActive }"
  >
    <div
      tabindex="0"
      class="faq-question"
      @click="clickQuestion(index)"
    >
      <span>{{ index + 1 }}.</span>
      {{ question?.question }}
      <div class="faq-arrow">
        <Arrow :direction="isActive ? 'up' : 'down'" />
      </div>
    </div>
    <Markdown
      class="faq-answer"
      :source="question?.answer"
    />
  </div>
</template>

<script>
import Markdown from 'vue3-markdown-it';
import Arrow from '@/components/Icons/Arrow.vue'

export default {
  name: 'QuestionText',
  components: {
    Arrow,
    Markdown
  },
  props: {
    isActive: Boolean,
    clickQuestion: Function,
    index: Number,
    question: Object
  }
}
</script>

<style lang="scss">
.faq-question-content {
  position: relative;
  margin: 0 0 6px;
  border-left: 2px solid transparent;
  transition: border-color 220ms ease-out, background-color 220ms ease-out;

  .faq-question {
    cursor: pointer;
    font-weight: bold;
    position: relative;
    padding: 20px 60px 20px 60px;
    transition: color 200ms ease-out;

    span {
      top: 20px;
      left: 20px;
      width: 15px;
      font-weight: bold;
      margin-right: 20px;
      position: absolute;
      display: inline-block;
      color: var(--bzioup-color-pink);
    }

    .faq-arrow {
      top: 20px;
      right: 20px;
      width: 20px;
      height: 20px;
      cursor: pointer;
      position: absolute;
      transition: transform 200ms ease-out;
    }
  }

  .faq-answer {
    margin: 0;
    max-height: 0px;
    overflow-y: hidden;
    padding: 0px 60px 0px 60px;
    transition: max-height 0s ease-in-out, padding 0s ease-in-out;
  }
}

/* Hover: subtle pink-soft wash + the question text gets a touch
   warmer, so the row reads as "tappable" before the click. */
.faq-question-content:hover {
  background-color: var(--bzioup-color-pink-soft);
  border-left-color: var(--bzioup-color-pink);
}

/* Active (expanded) question. Pink left accent persists, question
   color shifts to brand pink so the open one is unambiguous in a
   list. Arrow rotates 180deg (via the Arrow component's direction
   prop), but we also nudge color via inherited fill. */
.faq-question-content.active {
  border-left-color: var(--bzioup-color-pink);
  background-color: var(--bzioup-color-pink-soft);

  .faq-question {
    color: var(--bzioup-color-pink);
  }

  .faq-answer {
    max-height: 1000px;
    padding: 0px 60px 14px 60px;
    transition: max-height 0.5s ease-in-out, padding 0.25s ease-in;
  }
}
</style>